// extracted by mini-css-extract-plugin
module.exports = {"root":"pagination_root__LxrOY","numbers":"pagination_numbers__8sxph","legend":"pagination_legend___rr1_"};